
import './App.css';
import Navbar from './components/Navbar';
import Section2 from './components/Section2';
import Section from './components/Section';
import Form from './components/Form';
import Footer from './components/Footer';

function App() {
  return (
   <>
   <Navbar></Navbar>
   <Section></Section>
   <Section2></Section2>
   <Form></Form>
   <Footer></Footer>
   </>
  );
}

export default App;
